export const installmentScheduleTypeConstants = {
  TWO_WEEKS_BEFORE: "TwoWeeksBefore",
};
